import { useState, useEffect } from 'react';
import { getTheStorage } from '../../../api/businessAndEnterprise/businessAndEnterpriseApi';
import cloud from '../../../assets/images/storage_cloud.svg';
import { useNavigate } from 'react-router-dom';

const StorageSection = ({ isSidebarOpen }) => {
    const [storageData, setStorageData] = useState({ used: 0, total: 0 });
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        getTheStorage({}, (response) => {
            if (response?.status && response?.data) {
                const storageInfo = response.data;
                setStorageData({
                    used: storageInfo.used_mb,
                    total: storageInfo.used_mb + storageInfo.remaining_mb 
                });
            }
            setLoading(false);
        });
    }, []);

    const usedPercentage = Math.min((storageData.used / storageData.total) * 100, 100);

    if (!isSidebarOpen) {
        return (
            <div onClick={() => navigate('/storage')} className="w-full flex items-center justify-center cursor-pointer group">
                <img
                    src={cloud}
                    alt="Storage Icon"
                    className="!w-[28px] h-[19px] !ml-2 !object-contain opacity-80 group-hover:opacity-100 transition-opacity"
                />
                <span className="tooltip">Storage</span>
            </div>
        );
    }

    return (
        <div className="w-full px-1 py-3 bg-transparent">
            <div className="flex items-center gap-1 mb-1.5">
                <img
                    src={cloud}
                    alt="Storage Icon"
                    className="!w-[32px] h-[19px] !object-contain"
                />
                <span className="text-[#FFFFFF] text-base font-normal leading-none">Storage</span>
            </div>

            <div className="w-full bg-[#363636] h-1.5 rounded-full mb-2 overflow-hidden">
                <div
                    className="bg-white h-full transition-all duration-500 ease-in-out"
                    style={{ width: `${usedPercentage}%` }}
                ></div>
            </div>

            <p className="text-[#BDBDBD] text-xs mb-3">
                {storageData.used >= 1024
                    ? `${(storageData.used / 1024).toFixed(1)} GB`
                    : `${storageData.used} MB`} of {storageData.total / 1024} GB used
            </p>

            <button onClick={() => navigate('/storage')} className="w-full py-1.5 px-3 border border-[#FFFFFFA8] rounded-[4px] text-white text-sm font-bold hover:bg-[#19202C] transition-colors">
                Get More Storage
            </button>
        </div>
    );
};

export default StorageSection;